import { gql } from 'apollo-boost-upload'

export const CREATE_REMINDERS = gql`
  mutation CreateReminders($input: CreateRemindersInput!) {
    createReminders(input: $input) {
      genre
      insuranceType
      insurer
      renewalMonth
      annualPayment
    }
  }
`;

export const UPDATE_LAST_REMINDER = gql`
  mutation UpdateLastReminder($userId: String!) {
    updateLastReminder(userId: $userId)
  }
`;

export const CAN_SHOW_REMINDERS = gql`
  query CanShowReminders($userId: String!) {
    canShowReminders(userId: $userId)
  }
`;

export const GET_REMINDERS = gql`
  query GetReminders($userId: String!) {
    getReminders(userId: $userId) {
      uuidUser
      type
      insurer
      renewalMonth
      annualPayment
    }
  }
`;
